import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ProjectDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface RestoreProjectApiResponse {
  success: boolean;
  data: ProjectDto;
}

/**
 * Mutation hook for restoring a soft-deleted project (Owner/Admin only).
 * Calls POST /projects/:id/restore.
 * Invalidates the projects list so the restored project reappears.
 */
export function useRestoreProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await apiClient.post<RestoreProjectApiResponse>(`/projects/${id}/restore`);
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.list() });
    },
  });
}
